import { render, staticRenderFns } from "./tableShiftNew.vue?vue&type=template&id=3e640523&scoped=true"
import script from "./tableShiftNew.vue?vue&type=script&lang=js"
export * from "./tableShiftNew.vue?vue&type=script&lang=js"
import style0 from "./tableShiftNew.vue?vue&type=style&index=0&id=3e640523&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e640523",
  null
  
)

export default component.exports